import React, { Component } from 'react';

import './style.css';

export default class AdminTitle extends Component {

  render() {
    return (
      <div className="admin-title">
        <h2 className="admin-title-text">{this.props.title}</h2>
        <nav className="admin-title-nav">
          {this.props.children}
        </nav>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AdminTitle/index.js
 **/